const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/marque/api-factory');
const serviceFactory = require('../resources/marque/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/userprofile/${apiConfig.apiversion}/`,
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';


  return app => app
      
      .match(`${p}marque.getAllMarqueData[{keys:channel}][{keys:ran_str}]`, requests => Promise.all(
       requests.map(({ req, res }) => 
        service.getAllMarqueData(req.params)
           .then(response => res.value(response))
           .catch(res.error)
      )))
      
      .match(`${p}marque.saveMarqueData[{keys:requestBody}]`, requests => Promise.all(
        requests.map(({ req, res }) => 
         service.saveMarqueData(req.params)
            .then(response => res.value(response))
            .catch(res.error)
       )));

}

module.exports = addRoutes;
